import axiosInstance from 'Api';

const fetchDocument = (query)=>{
    return axiosInstance.get(`documents?${query}`);
};

const UpdateStatus = (data)=>{
    return axiosInstance.post('document/update-status', data)
}

const SupportService = {
    fetchDocument,
    UpdateStatus
};
export default SupportService;